'use strict';

import { Buffer } from 'buffer';
import Path from 'path';
import pluginError from 'plugin-error';
import through2 from 'through2';
import Vinyl from 'vinyl';
import * as util from '../utilities';
import * as Resjson from './resjson-convert';

const PLUGIN_NAME = 'gulp-resjson';

interface Options {
    /**
     * enable to produce xxxx.d.ts file.
     * { null, 'module' }
     */
    definition: string;

    /**
     * enable to produce xxxx.ts file.
     * { null, 'module', 'interface' }
     */
    typescript: string;

    /**
     * enable to produce xxxx.json file.
     */
    json: boolean;

    /**
     * if set a space characters, it adds formating of JSON.
     * it set null, space will be eliminated.
     */
    jsonSpace: string | number;

    /**
     * specify the conversion is Localized file with folder offset.
     */
    localeOffset: number;

    /**
     * src root.
     */
    srcRoot?: string;
}

function gulpResjson(options: Options) {
    // override options settings if not specified.
    options = <Options>Object.assign({ definition: null, typescript: null, json: false, jsonSpace: null }, options || {});

    return through2.obj(
        /**
         * Transform
         */
        function (file, encoding, callback) {
            let error = null;
            try {
                if (file.isNull()) {
                    // nothing to do
                    return callback(null, file);
                }

                if (file.isStream()) {
                    // file.contents is a Stream - https://nodejs.org/api/stream.html
                    this.emit('error', new pluginError(PLUGIN_NAME, 'Streams not supported!'));
                    return callback(null, file);
                } else if (file.isBuffer()) {
                    const data = file.contents.toString('utf8');
                    const converter = new Resjson.ResJsonConverter(options);
                    converter.convert(data, file.base.indexOf('src\\resources') >= 0);

                    const path = Path.parse(file.path);
                    if (options.definition) {
                        const dtFile = new Vinyl({
                            cwd: '/',
                            base: path.dir,
                            path: path.dir + '/' + path.name + '.d.ts',
                            contents: Buffer.from(converter.contentDefinition, 'utf8')
                        });
                        this.push(dtFile);
                    }

                    if (options.typescript) {
                        const content = options.typescript === 'interface' ? converter.contentInterface : converter.contentTypescript;
                        const tsFile = new Vinyl({
                            cwd: '/',
                            base: path.dir,
                            path: path.dir + '/' + path.name + '.ts',
                            contents: Buffer.from(content, 'utf8')
                        });
                        this.push(tsFile);
                    }

                    if (options.json) {
                        let baseDir = options.srcRoot || path.dir;
                        let fullDir = path.dir;
                        if (typeof options.localeOffset === 'number') {
                            const segments = path.dir.split('\\');
                            segments.length = segments.length - options.localeOffset;
                            fullDir = segments.join('\\');
                            segments.length = segments.length - 1;
                            baseDir = segments.join('\\');
                        }

                        const content = JSON.stringify(converter.outputJson, null, options.jsonSpace);
                        const jsonFile = new Vinyl({
                            cwd: '/',
                            base: baseDir,
                            path: fullDir + '\\' + path.name + '.json',
                            contents: Buffer.from(content, 'utf8')
                        });
                        this.push(jsonFile);
                    }
                }
            } catch (e) {
                error = (!e.plugin || (e.plugin !== PLUGIN_NAME)) ?
                    util.extendError(new pluginError({ plugin: PLUGIN_NAME, message: e.message }), e) : e;
            }

            callback(error);
        });
}

module.exports = gulpResjson;
